"use strict";
import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var winner = (function () {

    var winnerList = $('.winner-list');

    if (winnerList.length > 0) {

        var main = $('#main'),
			source = $("#winner-list-template").html(),
			loadMoreBtn = $('#more-winners'),
			template = Handlebars.compile(source),
			responseWrap = loadMoreBtn.closest('.module').find('.response-wrapper'),
			cl;

        if (loadMoreBtn.length > 0) {

            cl = new CanvasLoader('loader');

            cl.setDiameter(20);
            cl.setDensity(17);
            cl.setRange(1.1);
            cl.setSpeed(1);
            cl.setColor('#ffffff');
            cl.setFPS(24);
        }

        main.on('click', '#more-winners', function (e) {
            e.preventDefault();

            var data = {
                lastShowedWinner: $("#winners-list li:last-child").data("pageid"),
                pageId: SETTINGS.pageid
            }

            loadMoreBtn.addClass('loading');
            cl.show();
            responseWrap.hide();

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.admin.methods.getWinners,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        });
    }

    function doneHandler(response) {

        if (response.Success) {
            var html = template(response.Data);

            if (!response.MoreAvailable) {
                loadMoreBtn.hide();
            }
            
            winnerList.append(html);

        } else {
            displayGenericError(responseWrap, response);                       
        }
        cl.hide();

        loadMoreBtn.removeClass('loading');
    }

    function failHandler(jqXHR, textStatus, errorThrown) {
        serviceNetworkError(responseWrap);
        loadMoreBtn.removeClass('loading');
        cl.hide();
    }

})();